import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";

Vue.use(VueRouter);

// Layout
import UnAuthLayout from "../views/layouts/unauth-layout.vue";
import AuthLayout from "../views/layouts/auth-layout.vue";

// Static
import HomePage from "../views/home";

// Auth
import LoginPage from "../views/auth/login.vue";
import ForgotPasswordPage from "../views/auth/forgot-password.vue";

// Companies
import CompaniesPage from "../views/companies/index.vue";
import CompanyCreatePage from "../views/companies/create.vue";
import CompanyIdPage from "../views/companies/id.vue";

// Users
import UsersPage from "../views/users/index.vue";
import UserCreatePage from "../views/users/create.vue";
import UserIdPage from "../views/users/id.vue";
import ProfilePage from "../views/users/id.vue";
import UsersUploadPage from "../views/users/upload.vue";

// Positions
import PositionsPage from "../views/positions/index.vue";
import PositionCreatePage from "../views/positions/create.vue";
import PositionIdPage from "../views/positions/id.vue";

// Roles
import RolesPage from "../views/roles/index.vue";
import RoleIdPage from "../views/roles/id.vue";

// Modules
import ModulesPage from "../views/modules/index.vue";
import ModuleCreatePage from "../views/modules/create.vue";
import ModuleIdPage from "../views/modules/id.vue";


// Permissions
import PermissionsPage from "../views/permissions/index.vue";
import PermissionCreatePage from "../views/permissions/create.vue";
import PermissionIdPage from "../views/permissions/id.vue";

// Values
import Values from "@/views/values/index.vue";
import ValueCreate from "@/views/values/create.vue";
import ValueId from "@/views/values/id.vue";

// ValueLists
import ValueLists from "@/views/value-lists/index.vue";
import ValueListUpload from "@/views/value-lists/upload.vue";
import ValueListCreate from "@/views/value-lists/create.vue";
import ValueListId from "@/views/value-lists/id.vue";

// Posts & Moderation
import PostsPage from "@/views/posts/index.vue";
import ModerationPage from "@/views/moderation/index.vue";

// AI Agents & Marketplace
import AIAgentsPage from "@/views/ai-agents/index.vue";
import AIAgentCreatePage from "@/views/ai-agents/create.vue";
import AIAgentEditPage from "@/views/ai-agents/edit.vue";
import IndustriesPage from "@/views/industries/index.vue";
import SubscriptionsPage from "@/views/subscriptions/index.vue";
import SubscriptionCreatePage from "@/views/subscriptions/create.vue";
import SubscriptionViewPage from "@/views/subscriptions/view.vue";
import SubscriptionEditPage from "@/views/subscriptions/edit.vue";
import CouponsPage from "@/views/coupons/index.vue";
import MySubscriptionsPage from "@/views/my-subscriptions/index.vue";
import AvailableSubscriptionsPage from "@/views/available-subscriptions/index.vue";
import ActiveSubscriptionsPage from "@/views/active-subscriptions/index.vue";
import PastSubscriptionsPage from "@/views/past-subscriptions/index.vue";

// Other pages
import NotificationsPage from "@/views/notifications.vue";

// ContentMod AI Specific Pages
import ContentModAIDashboard from "@/views/agents/contentmod-ai/dashboard.vue";
import ContentModAIModeration from "@/views/agents/contentmod-ai/moderation.vue";
import ContentModAIPosts from "@/views/agents/contentmod-ai/posts.vue";

// LeadRanker AI Specific Pages
import LeadRankerAIDashboard from "@/views/agents/leadranker-ai/dashboard.vue";
import LeadRankerAILeads from "@/views/agents/leadranker-ai/leads.vue";
import LeadRankerAIScoring from "@/views/agents/leadranker-ai/scoring.vue";

// PitchCrafter AI Specific Pages
import PitchCrafterAIDashboard from "@/views/agents/pitchcrafter-ai/dashboard.vue";
import PitchCrafterAIProposals from "@/views/agents/pitchcrafter-ai/proposals.vue";
import PitchCrafterAIResults from "@/views/agents/pitchcrafter-ai/results.vue";

// FollowUpBot AI Specific Pages
import FollowUpBotAIDashboard from "@/views/agents/followupbot-ai/dashboard.vue";
import FollowUpBotAICampaigns from "@/views/agents/followupbot-ai/campaigns.vue";
import FollowUpBotAIMessages from "@/views/agents/followupbot-ai/messages.vue";
import FollowUpBotAIAnalytics from "@/views/agents/followupbot-ai/analytics.vue";

// CRMGenie AI Specific Pages
import CRMGenieAIDashboard from "@/views/agents/crmgenie-ai/dashboard.vue";
import CRMGenieAIDataProcessing from "@/views/agents/crmgenie-ai/data-processing.vue";
import CRMGenieAIEnrichment from "@/views/agents/crmgenie-ai/enrichment.vue";
import CRMGenieAIDuplicates from "@/views/agents/crmgenie-ai/duplicates.vue";
import CRMGenieAIReports from "@/views/agents/crmgenie-ai/reports.vue";



const routes = [
  // Root redirect
  {
    path: "/",
    redirect: "/home"
  },
  // AuthLayout
  {
    path: "/auth",
    name: "AuthLayout",
    component: AuthLayout,
    children: [
      {
        path: "/home",
        name: "HomePage",
        component: HomePage,
      },
      // Comapnies
      {
        path: "/companies",
        name: "CompaniesPage",
        component: CompaniesPage,
      },
      {
        path: "/companies/create",
        name: "CompanyCreatePage",
        component: CompanyCreatePage,
      },
      {
        path: "/companies/:companyId",
        name: "CompanyIdPage",
        component: CompanyIdPage,
      },
      // Users
      {
        path: "/users",
        name: "UsersPage",
        component: UsersPage,
      },
      {
        path: "/users/create",
        name: "UserCreatePage",
        component: UserCreatePage,
      },
      {
        path: "/users/upload",
        name: "UsersUploadPage",
        component: UsersUploadPage,
      },
      {
        path: "/profile/:userId",
        name: "ProfilePage",
        component: ProfilePage,
      },
      {
        path: "/users/:userId",
        name: "UserIdPage",
        component: UserIdPage,
      },
      // Positions
      {
        path: "/positions",
        name: "PositionsPage",
        component: PositionsPage,
      },
      {
        path: "/positions/create",
        name: "PositionCreatePage",
        component: PositionCreatePage,
      },
      {
        path: "/positions/:positionId",
        name: "PositionIdPage",
        component: PositionIdPage,
      },
      // Roles
      {
        path: "/roles",
        name: "RolesPage",
        component: RolesPage,
      },
      {
        path: "/roles/:roleId",
        name: "RoleIdPage",
        component: RoleIdPage,
      },
      // Modules
      {
        path: "/modules",
        name: "ModulesPage",
        component: ModulesPage,
      },
      {
        path: "/modules/create",
        name: "ModuleCreatePage",
        component: ModuleCreatePage,
      },
      {
        path: "/modules/:moduleId",
        name: "ModuleIdPage",
        component: ModuleIdPage,
      },
      // Permissions
      {
        path: "/permissions",
        name: "PermissionsPage",
        component: PermissionsPage,
      },
      {
        path: "/permissions/create",
        name: "PermissionCreatePage",
        component: PermissionCreatePage,
      },
      {
        path: "/permissions/:permissionId",
        name: "PermissionIdPage",
        component: PermissionIdPage,
      },
      // Values
      {
        path: "/values",
        name: "Values",
        component: Values,
      },
      {
        path: "/values/create",
        name: "ValueCreate",
        component: ValueCreate,
      },
      {
        path: "/values/:valueId",
        name: "ValueId",
        component: ValueId,
      },
      // ValueLists
      {
        path: "/value-lists",
        name: "ValueLists",
        component: ValueLists,
      },
      {
        path: "/value-lists/upload",
        name: "ValueListUpload",
        component: ValueListUpload,
      },
      {
        path: "/value-lists/create",
        name: "ValueListCreate",
        component: ValueListCreate,
      },
      {
        path: "/value-lists/:valueListId",
        name: "ValueListId",
        component: ValueListId,
      },
      // Posts
      {
        path: "/posts",
        name: "PostsPage",
        component: PostsPage,
      },
      // Moderation
      {
        path: "/moderation",
        name: "ModerationPage",
        component: ModerationPage,
      },
      // AI Agents & Marketplace
      {
        path: "/ai-agents",
        name: "AIAgentsPage",
        component: AIAgentsPage,
      },
      {
        path: "/ai-agents/create",
        name: "AIAgentCreatePage",
        component: AIAgentCreatePage,
      },
      {
        path: "/ai-agents/:id/edit",
        name: "AIAgentEditPage",
        component: AIAgentEditPage,
      },
      {
        path: "/industries",
        name: "IndustriesPage",
        component: IndustriesPage,
      },
      {
        path: "/subscriptions",
        name: "SubscriptionsPage",
        component: SubscriptionsPage,
      },
      {
        path: "/subscriptions/create",
        name: "SubscriptionCreatePage",
        component: SubscriptionCreatePage,
      },
      {
        path: "/subscriptions/:id",
        name: "SubscriptionViewPage",
        component: SubscriptionViewPage,
      },
      {
        path: "/subscriptions/:id/edit",
        name: "SubscriptionEditPage",
        component: SubscriptionEditPage,
      },
      {
        path: "/coupons",
        name: "CouponsPage",
        component: CouponsPage,
      },
      {
        path: "/my-subscriptions",
        name: "MySubscriptionsPage",
        component: MySubscriptionsPage,
      },
      {
        path: "/available-subscriptions",
        name: "AvailableSubscriptionsPage",
        component: AvailableSubscriptionsPage,
      },
      {
        path: "/active-subscriptions",
        name: "ActiveSubscriptionsPage",
        component: ActiveSubscriptionsPage,
      },
      {
        path: "/past-subscriptions",
        name: "PastSubscriptionsPage",
        component: PastSubscriptionsPage,
      },
      {
        path: "/notifications",
        name: "NotificationsPage",
        component: NotificationsPage,
      },
      // ContentMod AI Agent Specific Routes
      {
        path: "/agents/contentmod-ai/dashboard",
        name: "ContentModAIDashboard",
        component: ContentModAIDashboard,
      },
      {
        path: "/agents/contentmod-ai/moderation",
        name: "ContentModAIModeration",
        component: ContentModAIModeration,
      },
      {
        path: "/agents/contentmod-ai/posts",
        name: "ContentModAIPosts",
        component: ContentModAIPosts,
      },
      // LeadRanker AI Agent Specific Routes
      {
        path: "/agents/leadranker-ai/dashboard",
        name: "LeadRankerAIDashboard",
        component: LeadRankerAIDashboard,
      },
      {
        path: "/agents/leadranker-ai/leads",
        name: "LeadRankerAILeads",
        component: LeadRankerAILeads,
      },
      {
        path: "/agents/leadranker-ai/leads/:id",
        name: "LeadRankerAILeadDetails",
        component: LeadRankerAILeads, // Can be enhanced with a detail component later
      },
      {
        path: "/agents/leadranker-ai/scoring",
        name: "LeadRankerAIScoring",
        component: LeadRankerAIScoring,
      },
      // PitchCrafter AI Agent Specific Routes
      {
        path: "/agents/pitchcrafter-ai/dashboard",
        name: "PitchCrafterAIDashboard",
        component: PitchCrafterAIDashboard,
      },
      {
        path: "/agents/pitchcrafter-ai/proposals",
        name: "PitchCrafterAIProposals",
        component: PitchCrafterAIProposals,
      },
      {
        path: "/agents/pitchcrafter-ai/proposals/:id",
        name: "PitchCrafterAIProposalDetails",
        component: PitchCrafterAIProposals, // Can be enhanced with a detail component later
      },
      {
        path: "/agents/pitchcrafter-ai/results",
        name: "PitchCrafterAIResults",
        component: PitchCrafterAIResults,
      },
      // FollowUpBot AI Agent Specific Routes
      {
        path: "/agents/followupbot-ai/dashboard",
        name: "FollowUpBotAIDashboard",
        component: FollowUpBotAIDashboard,
      },
      {
        path: "/agents/followupbot-ai/campaigns",
        name: "FollowUpBotAICampaigns",
        component: FollowUpBotAICampaigns,
      },
      {
        path: "/agents/followupbot-ai/campaigns/:id",
        name: "FollowUpBotAICampaignDetails",
        component: FollowUpBotAICampaigns, // Can be enhanced with a detail component later
      },
      {
        path: "/agents/followupbot-ai/messages",
        name: "FollowUpBotAIMessages",
        component: FollowUpBotAIMessages,
      },
      {
        path: "/agents/followupbot-ai/messages/:id",
        name: "FollowUpBotAIMessageDetails",
        component: FollowUpBotAIMessages, // Can be enhanced with a detail component later
      },
      {
        path: "/agents/followupbot-ai/analytics",
        name: "FollowUpBotAIAnalytics",
        component: FollowUpBotAIAnalytics,
      },
      // CRMGenie AI Agent Specific Routes
      {
        path: "/agents/crmgenie-ai/dashboard",
        name: "CRMGenieAIDashboard",
        component: CRMGenieAIDashboard,
      },
      {
        path: "/agents/crmgenie-ai/data-processing",
        name: "CRMGenieAIDataProcessing",
        component: CRMGenieAIDataProcessing,
      },
      {
        path: "/agents/crmgenie-ai/enrichment",
        name: "CRMGenieAIEnrichment",
        component: CRMGenieAIEnrichment,
      },
      {
        path: "/agents/crmgenie-ai/duplicates",
        name: "CRMGenieAIDuplicates",
        component: CRMGenieAIDuplicates,
      },
      {
        path: "/agents/crmgenie-ai/reports",
        name: "CRMGenieAIReports",
        component: CRMGenieAIReports,
      },
    ],
  },
  // End AuthLayout

  // UnAuthLayout
  {
    path: "/unauth",
    name: "UnAuthLayout",
    component: UnAuthLayout,
    children: [
      {
        path: "/login",
        name: "LoginPage",
        component: LoginPage,
      },
      {
        path: "/forgot-password",
        name: "ForgotPasswordPage",
        component: ForgotPasswordPage,
      },
    ],
  },
  //End UnAuthLayout
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  console.log("=== Navigation Guard Debug ===");
  console.log("From:", from.name, from.path);
  console.log("To:", to.name, to.path);
  console.log("Authenticated:", store.getters["auth/authenticated"]);
  console.log("User:", store.getters["auth/user"]?.email);
  console.log("Company:", store.getters["auth/company"]?.id);
  
  if (
    to.name === "LoginPage" ||
    to.name === "RegisterPage" ||
    to.name === "ForgotPasswordPage"
  ) {
    console.log("Branch 1: Auth page accessed");
    if (store.getters["auth/authenticated"]) {
      console.log("Branch 1a: Already authenticated, redirecting to home");
      return next({
        name: "HomePage",
      });
    }
    console.log("Branch 1b: Not authenticated, allowing access to auth page");
    next();
  } else if (!store.getters["auth/authenticated"]) {
    console.log("Branch 2: Not authenticated, redirecting to login");
    return next({
      name: "LoginPage",
    });
  } else if (to.name === null) {
    console.log("Branch 3: Route name is null, redirecting to home");
    return next({
      name: "HomePage",
    });
  } else {
    console.log("Branch 4: Allowing navigation");
    next();
  }
});


export default router;
